// src/components/SchoolList.js
import React from 'react';

const SchoolList = ({ schools, onSelect }) => {
  return (
    <div className="max-w-5xl bg-white rounded shadow p-6 mx-auto">
      <h2 className="text-xl font-semibold mb-4">Schools</h2>
      <table className="w-full text-left border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">School Name</th>
            <th className="p-2 border">POC Name</th>
            <th className="p-2 border">POC Mobile</th>
            <th className="p-2 border">School Area</th>
            <th className="p-2 border"># Children</th>
          </tr>
        </thead>
        <tbody>
          {schools.map((school) => (
            <tr
              key={school.id}
              className="hover:bg-gray-50 cursor-pointer"
              onClick={() => onSelect(school)}
            >
              <td className="p-2 border">{school.schoolname}</td>
              <td className="p-2 border">{school.pocname || '-'}</td>
              <td className="p-2 border">{school.pocmobile || '-'}</td>
              <td className="p-2 border">{school.schoolarea || '-'}</td>
              <td className="p-2 border">{school.numbeofchildren}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SchoolList;
